import translations from './const/sp.json';

const sp = {
  translation: {
    ...translations
  }
}

export default sp;